import type { IDirective } from "angular";
import { module } from "angular";

export default class BindNewLinesDirective implements IDirective {
    public scope = {
        irBindNewLines: "=",
    };

    public link($scope: any, element: JQuery) {
        $scope.$watch(
            () => $scope.irBindNewLines,

            (newVal: string) => {
                if (newVal) {
                    const htmlVal = newVal.replace(/(?:\r\n|\r|\n)/g, "<br>");
                    element.html(htmlVal);
                }
            },
        );
    }
}

module("mmGui").directive("irBindNewLines", () => new BindNewLinesDirective());
